import React from 'react';
import { Grid, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { GenericTrackingCard, IEntry } from '../components/GenericTrackingCard';
import { useApiRepo, Endpoints } from '../utils/Api';
import { LinkButton } from '../components/LinkButton';
import { ObsessionCompulsionFilter } from '../components/ObsessionCompulsionFilter';
import BanBookImage from '../assets/ocdfeat-ban-book.svg';
import squiggle from '../assets/squiggle.jpeg';

enum BanBookTypes {
  RESISTS = 'resist',
  COMPETING_RESPONSE = 'competing_response',
  SUBMIT = 'submit'
}

type BanBookResponse = IEntry & {
  [key in BanBookTypes]: number;
};

const mapBanBookEntries = (accommodationEntries: Record<string, any>) => (
  <>
    {accommodationEntries.map((entry: BanBookResponse) => (
      <Grid item xs={3} key={entry.compulsion_id} style={{ minWidth: '400px' }}>
        <GenericTrackingCard<`${BanBookTypes}`>
          entry={entry}
          top={{
            enumValue: BanBookTypes.RESISTS,
            title: 'RESISTS',
            value: entry.resist
          }}
          middle={{
            enumValue: BanBookTypes.COMPETING_RESPONSE,
            title: 'COMPETING RESPONSES',
            value: entry.competing_response
          }}
          bottom={{
            enumValue: BanBookTypes.SUBMIT,
            title: 'SUBMITS',
            value: entry.submit
          }}
        />
      </Grid>
    ))}
  </>
);

export function BanBook() {
  const { getObjectsFromAPI } = useApiRepo();
  const [banBook, setBanBook] = React.useState([]);
  const [filteredBanBook, setfilteredBanBook] = React.useState([]);

  async function getBanBook() {
    const api = await getObjectsFromAPI();
    const res = await api.get(Endpoints.banBook);
    setBanBook(res.data.data);
    setfilteredBanBook(res.data.data);
  }

  // TODO Use link rather than navigate?
  const navigate = useNavigate();
  function NavigateToProfile() {
    navigate('/profile');
  }

  React.useEffect(() => {
    getBanBook();
  }, []);

  const titleStyle = {
    color: '#010d0d'
  };

  const textStyle = {
    fontSize: '18pt',
    color: '#010d0d'
  };

  function filterBanBook(selectedObsession: any, selectedCompulsion?: any) {
    const filteredObsessions = banBook.filter(
      (entry: any) => entry.obsession_id === selectedObsession.id
    );
    if (selectedCompulsion) {
      const filteredCompulsions = filteredObsessions.filter(
        (entry: any) => entry.compulsion_id === selectedCompulsion.id
      );
      setfilteredBanBook(filteredCompulsions);
      return;
    }
    setfilteredBanBook(filteredObsessions);
  }

  return (
    <Grid
      container
      direction="row"
      spacing={2}
      justifyContent="center"
      alignItems="center"
      style={{ padding: '60px' }}
    >
      <Grid container item xs={12} style={{ padding: '30px' }}>
        <Grid item xs={12} lg={6}>
          <Typography
            variant="h3"
            style={titleStyle}
            sx={{ typography: { sm: 'h3', xs: 'h4' } }}
          >
            Compulsion Tracker
          </Typography>
          <Grid item style={{ padding: '40px 0px 40px' }}>
            <img src={squiggle} alt="divderImage" style={{ height: '15px' }} />
          </Grid>
          <Typography
            variant="h6"
            style={textStyle}
            sx={{ display: { xs: 'none', lg: 'cover' } }}
          >
            This tool makes it easy to record a resist, submit, or competing
            response at home or on the go. Keep at it no matter how hard it
            gets! Consistent tracking in your compulsion tracker helps your
            therapist understand what’s happening when you’re not in session. If
            you’re on a waitlist, it will give your new therapist a snapshot of
            what’s been happening.
          </Typography>
          <Grid item style={{ padding: '40px 0px 40px' }}>
            <LinkButton
              buttonText="+ Add Compulsion Tracker Entry"
              handleClick={NavigateToProfile}
            />
          </Grid>
        </Grid>
        <Grid
          container
          item
          xs={12}
          lg={6}
          justifyContent="center"
          sx={{ display: { xs: 'none', lg: 'cover' } }}
        >
          <img src={BanBookImage} style={{ height: '500px' }} alt="tileImage" />
        </Grid>
      </Grid>
      <Grid
        container
        item
        xs={12}
        direction="row"
        spacing={2}
        justifyContent="center"
      >
        <ObsessionCompulsionFilter handleFilter={filterBanBook} />
      </Grid>
      <Grid
        container
        item
        xs={12}
        direction="row"
        spacing={2}
        justifyContent="center"
      >
        {mapBanBookEntries(filteredBanBook)}
      </Grid>
    </Grid>
  );
}
